import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@fortawesome/fontawesome-free/svgs/solid/location-arrow.svg'
import _imports_1 from '@fortawesome/fontawesome-free/svgs/solid/gauge-simple-high.svg'


const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card__title" }
const _hoisted_3 = { class: "weather-main-info" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "weather-main-info__temperature" }
const _hoisted_6 = { class: "weather-additional-info" }
const _hoisted_7 = { class: "weather-details" }
const _hoisted_8 = { class: "weather-details__detail" }
const _hoisted_9 = { class: "weather-details__detail" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon icon_small icon_before_text",
  alt: "Pressure"
}, null, -1)
const _hoisted_11 = { class: "weather-details__detail" }
const _hoisted_12 = { class: "weather-details__detail" }
const _hoisted_13 = { class: "weather-details__detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.weatherInfo.name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: _ctx.weatherInfo.icon,
        alt: _ctx.weatherInfo.summary,
        height: "100",
        width: "100"
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.weatherInfo.temperature) + _toDisplayString(_ctx.weatherInfo.temperatureUnits), 1)
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.feelsLikePhrase) + ". " + _toDisplayString(_ctx.cloudsPhrase) + ". " + _toDisplayString(_ctx.windPhrase) + ". ", 1),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "icon icon_small icon_before_text",
          style: _normalizeStyle(_ctx.windDirectionIconStyle),
          alt: "Wind direction arrow"
        }, null, 4),
        _createTextVNode(" " + _toDisplayString(_ctx.weatherInfo.windSpeed) + _toDisplayString(_ctx.weatherInfo.speedUnits) + ", " + _toDisplayString(_ctx.weatherInfo.windCardinalDirection), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createTextVNode(" " + _toDisplayString(_ctx.weatherInfo.pressure) + _toDisplayString(_ctx.weatherInfo.pressureUnits), 1)
      ]),
      _createElementVNode("div", _hoisted_11, " Humidity: " + _toDisplayString(_ctx.weatherInfo.humidity) + "% ", 1),
      _createElementVNode("div", _hoisted_12, " Dew point: " + _toDisplayString(_ctx.weatherInfo.dewPoint) + _toDisplayString(_ctx.weatherInfo.temperatureUnits), 1),
      _createElementVNode("div", _hoisted_13, " Visibility: " + _toDisplayString(_ctx.formattedVisibility) + _toDisplayString(_ctx.weatherInfo.distanceUnits), 1)
    ])
  ]))
}